import { Network } from '../enums/network'

export const generalConfig = {
  API_URL: 'https://api.overtime.io',
  OVERDROP_API_URL: 'https://overdrop.overtime.io',
  PYTH_API_URL: 'https://hermes.pyth.network/v2/updates/price/latest',
}

export const noCacheConfig = {
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
    'x-api-key': 'c215a6ca-9eef-481e-a011-534f4b7cd32c',
  },
}

export const betTokenAddress = {
  [Network.OptimismMainnet]: '0xff6535c1F971245435429A915aB9eB1713beC1C1',
  [Network.Arbitrum]: '0xff6535c1F971245435429A915aB9eB1713beC1C1',
  [Network.Base]: '0xff6535c1F971245435429A915aB9eB1713beC1C1',
  [Network.OptimismSepolia]: '0xff6535c1F971245435429A915aB9eB1713beC1C1',
}
